/* global Forms, ReactOnRails */
import ApplicationController from './application_controller'

class EmployeeSuccessionPlanningFormController extends ApplicationController {
  static targets = ['startDate', 'hours', 'plannedAs']

  connect () {
    // Prevent Turbo from intercepting the form submission. Without this, Turbo
    // handles the POST and the subsequent redirect, which resets any Turbo Frames
    // on the page (e.g. the History tab) into a skeleton loading state.
    // data-remote='true' lets Rails UJS handle it as AJAX so create.js.erb can run.
    this.element.dataset.turbo = 'false'
    this.element.dataset.remote = 'true'
    Forms.initSelect2(this.element)
    Forms.initCheckbox(this.element)
    Forms.initDatePickers(this.element)

    window.requestAnimationFrame(() => {
      if (typeof ReactOnRails !== 'undefined' && typeof ReactOnRails.reactOnRailsPageLoaded === 'function') {
        try {
          ReactOnRails.reactOnRailsPageLoaded()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e)
        }
      }
    })
  }

  schedule () {
    const radioButtons = document.querySelectorAll('input[name="employee_suitable_position[employee_position_id]"]')
    radioButtons.forEach((radioButton) => {
      radioButton.checked = false
    })

    $(this.element).on('shown.bs.collapse', () => {
      this.startDateTarget.required = true
      this.hoursTarget.required = true
      this.plannedAsTarget.value = 'secondary'
    })

    $(this.element).on('hidden.bs.collapse', () => {
      this.startDateTarget.required = false
      this.hoursTarget.required = false
      this.plannedAsTarget.value = 'not_planned'
    })
  }

  checkPosition () {
    this.plannedAsTarget.value = 'primary'
  }

  handleHours (event) {
    const { value } = event.target
    const matched = value.match(/^([0-9]+(\.?[0-9]?[0-9]?)?)/)
    if (matched && parseFloat(matched[0]) < parseFloat(value)) {
      event.target.value = parseFloat(value).toFixed(2)
    }
  }
}

export default EmployeeSuccessionPlanningFormController
